import type { QuizStep, QuizStepAnswer } from '@search/graphql-typings';

export type QuizStepItemResult = Record<string, Array<string>>;

export type QuizStepResult = {
    main: QuizStepItemResult;
    extra?: QuizStepItemResult;
};

export const getInitialQuizResult = (steps: Array<QuizStep>): Array<QuizStepResult> => {
    const getInitialItemResult = (answer: QuizStepAnswer) => answer.isMulti ? [] : [ answer.options[0] ];

    return steps.map(step => ({
        main: {
            [step.internalName]: getInitialItemResult(step.answer)
        },
        ...step.additional ? {
            extra: {
                [step.additional.title]: getInitialItemResult(step.additional.answer)
            }
        } : {}
    }));
};

export const getStepItemFormattedResult = (item?: QuizStepItemResult) => {
    if (! item) {
        return null;
    }

    const label = Object.keys(item)[0];
    const value = item[label];

    const resultValue = value.length ? value.join(', ') : '';

    return {
        label,
        value: resultValue,
        formatted: resultValue.length ? `${label}: ${resultValue}` : ''
    };
};

export const makeEmail = ({
    phone,
    quizResult,
    quizId
}: {
    phone: string;
    quizId: string;
    quizResult: Array<QuizStepResult>;
}) => {
    const formattedQuizResult = quizResult.map(({ main, extra }) => {
        const mainResult = getStepItemFormattedResult(main)?.formatted ?? '';
        const extraResult = getStepItemFormattedResult(extra)?.formatted ?? '';

        return [ mainResult, extraResult ]
            .filter(Boolean)
            .join('\n');
    });

    const urlQuery = window.location.href.split('?')[1] ?? '';

    return [
        `ID: ${quizId}`,
        urlQuery && `Query: ${urlQuery}`,
        `Телефон: ${phone}`,
        ...formattedQuizResult
    ]
        .filter(Boolean)
        .join('\n\n');
};
